import { Component, OnInit, } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import { MonitorsSlaInventoryMonitorService } from 'e5core-angular-services';
import { MonitorsSlaInventoryMonitorModel } from 'e5core-angular-services';
import { DatePipe } from '@angular/common';
import { MatSelectChange } from '@angular/material';
import { Observable, of } from 'rxjs';

export interface OptionMonth {
  value: DateRange;
  viewValue: string;
}

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export class MockInventoryService {
  public getMockedSlaInventoryCounts(): Observable<MonitorsSlaInventoryMonitorModel> {
    const incomingData: any = new Array();
    const model: MonitorsSlaInventoryMonitorModel = new MonitorsSlaInventoryMonitorModel();
    incomingData.push({
      interval: new Date('2018-12-05T11:52:10.113Z'),
      totalCount: 10,
      statusZeroCount: 4,
      statusOneCount: 3,
      statusTwoCount: 2,
      statusThreeCount: 1
    }, {
      interval: new Date('2018-12-06T11:52:10.113Z'),
      totalCount: 15,
      statusZeroCount: 5,
      statusOneCount: 5,
      statusTwoCount: 3,
      statusThreeCount: 2
    }, {
      interval: new Date('2018-12-07T11:52:10.113Z'),
      totalCount: 20,
      statusZeroCount: 6,
      statusOneCount: 6,
      statusTwoCount: 4,
      statusThreeCount: 3
    });
    model.data = incomingData;
    return of(model);
  }
}

@Component({
  selector: 'e5core-ui-monitor-sla-inventory-highcharts',
  templateUrl: './e5core-ui-monitor-sla-inventory-highcharts.component.html',
  styleUrls: ['./e5core-ui-monitor-sla-inventory-highcharts.component.css']
})
export class E5coreUiMonitorSlaInventoryHighchartsComponent implements OnInit {

  constructor(private monitorService: MonitorsSlaInventoryMonitorService, private datePipe: DatePipe) {  }

  model: MonitorsSlaInventoryMonitorModel;
  startDate = '2018-01-11T13:21:53.770Z';
  endDate = '2018-30-11T13:35:36.870Z';
  Highcharts = Highcharts;
  chartConstructor = 'chart';
  chartOptions = this.createChartOptions();
  chartCallback = null; // optional function, defaults to null
  updateFlag = false; // optional boolean
  oneToOneFlag = true; // optional boolean, defaults to false
  runOutsideAngularFlag = false;

  // Ready up Mock Service
  mockInventoryService: MockInventoryService = new MockInventoryService();

  // Let the component know if it should deal with real or mocked data
  isMocked: boolean;

  // Month drop-down variables
  currentDate: Date = new Date();
  optionMonths: OptionMonth[];
  currentDateRange: DateRange = {
    startDate: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1),
    endDate: new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0, 23, 59, 59, 999)
  };
  selectedOptionMonth: OptionMonth;
  selectedMonthViewValue: string;

  ngOnInit() {
    this.isMocked = true; // Set to false for production
    this.LoadChartObject(this.startDate, this.endDate);
    this.selectedOptionMonth = {
      value: this.currentDateRange,
      viewValue: this.datePipe.transform(this.currentDateRange.startDate, 'MMMM yyyy')
    };
    this.selectedMonthViewValue = this.selectedOptionMonth.viewValue;
    this.instantiateOptionMonths();
  }

  private addMonths(date: Date, months: number) {
    const newDate = date;
    newDate.setMonth(newDate.getMonth() + months);
    return (newDate);
  }

  private addToOptionMonths(startDate: Date, endDate: Date, negativeDirection: boolean) {
    const dates: Date[] = [];
    let currentDate = new Date(startDate);
    if (!negativeDirection) {
      while (currentDate <= endDate) {
        dates.push(currentDate);
        this.optionMonths.push({
          value: {
            startDate: new Date(currentDate),
            endDate: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
          },
          viewValue: this.datePipe.transform(currentDate, 'MMMM yyyy')
        });
        currentDate = this.addMonths(currentDate, 1);
      }
    }
  }

  private alterSelectedMonthOption(viewValue: string) {
    const selectedValue = this.optionMonths.filter(f => f.viewValue === viewValue);

    if (selectedValue.length === 0) {
      return;
    }

    this.selectedOptionMonth = {
      value: {
        startDate: selectedValue[0].value.startDate,
        endDate: selectedValue[0].value.endDate
      },
      viewValue: viewValue
    };
  }

  public reloadChart($event: MatSelectChange) {
    this.alterSelectedMonthOption(this.selectedMonthViewValue);
    const selectedDateRange = this.selectedOptionMonth.value;
    this.instantiateOptionMonths();
    this.LoadChartObject(selectedDateRange.startDate, selectedDateRange.endDate);
  }

  private instantiateOptionMonths() {
    this.optionMonths = [];

    const currentlySelectedDate = this.selectedOptionMonth.value.startDate;
    const startDate = new Date(currentlySelectedDate);
    const endDate = new Date(currentlySelectedDate);
    startDate.setMonth(startDate.getMonth() - 5);
    endDate.setMonth(endDate.getMonth() + 5);
    const today = new Date();
    if (endDate > today) {
      endDate.setMonth(today.getMonth());
    }
    this.addToOptionMonths(startDate, endDate, false);
  }

  // isMocked if set to true will return mock data rather than true data, please set to false for production unless testing
  public LoadChartObject(startDate: any, endDate: any, siteGroup ?: any, category1Id ?: any, category2Id ?: any,
    category3Id ?: any, archive ?: any, totalProperty ?: any) {
      if (this.isMocked) {
        this.mockInventoryService.getMockedSlaInventoryCounts().subscribe(
          model => {
            this.chartOptions = {
              ...this.chartOptions,
              xAxis: this.extractXAxis(model),
              series: this.extractSeries(model)
            };
            this.model = model;
          },
        );
      } else {
        //TODO:
        // this.monitorService.getMockedSlaInventoryCounts().subscribe(
        //   model => {
        //     this.chartOptions = {
        //       ...this.chartOptions,
        //       xAxis: this.extractXAxis(model),
        //       series: this.extractSeries(model)
        //     };
        //     this.model = model;
        //   },
        // );
      }
  }


  private extractXAxis(model: MonitorsSlaInventoryMonitorModel): any {
    // debugger;
    const output = {
      // categories: model.data.map(i => this.datePipe.transform(i.interval, 'dd MMM yyyy')),
      type: 'datetime',
      ordinal: false,
      mintickInterval: 24 * 3600 * 1000,
      title: { rotation: -45 },
      labels: {
       format: '<b class="xAxisLabel">{value: %e %b %y}</b>'
      }
    };
    return (output);
  }

  private extractSeries(model: MonitorsSlaInventoryMonitorModel): any {
    const series = [];
    const activeItems = [];
    const diarisedItems = [];
    const launchedItems = [];
    const qaItems = [];
    for (let i = 0; i < model.data.length; i++) {
      //TODO
      // launchedItems.push([model.data[i].interval.getTime(), model.data[i].statusZeroCount]);
      // activeItems.push([model.data[i].interval.getTime(), model.data[i].statusOneCount]);
      // diarisedItems.push([model.data[i].interval.getTime(), model.data[i].statusTwoCount]);
      // qaItems.push([model.data[i].interval.getTime(), model.data[i].statusThreeCount]);
    }
    series.push({ name: 'Active', color: '#add8e6', data: activeItems, drilldown: true, yAxis: 0 });
    series.push({ name: 'Diarised', color: '#a52a2a', data: diarisedItems, drilldown: true, yAxis: 0});
    series.push({ name: 'Launched', color: '#ffff00', data: launchedItems, drilldown: true, yAxis: 0});
    series.push({ name: 'QA', color: '#ffa500', data: qaItems, drilldown: true, yAxis: 0});
    return (series);
  }

  private drillDown(event) {
    alert(event) ;
  }

  createChartOptions() {
    const _this: E5coreUiMonitorSlaInventoryHighchartsComponent = this;
    return {
      chart: {
        type: 'column',
        events: {
          drilldown: function (event) {
              _this.drillDown(event);
          }
        }
      },
      title: {
        text: 'Work Inventory Monitor',
        style: {
          'fontSize': '16px',
          'font-weight': 'bold'
        }
      },
      xAxis: {
        categories: [],
        title: { rotation : -45}
      },
      yAxis: [{
        min: 0,
        title: {
          text: 'Work Item Count',
        },
        labels: {x: -15},
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color: 'gray'
          }
        }
      }],
      legend: {
        align: 'right',
        x: -30,
        verticalAlign: 'top',
        y: 25,
        floating: true,
        backgroundColor: 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false,
        itemStyle: {
          fontSize: '12px',
          font: '12pt',
        }
      },
      tooltip: {
        headerFormat: '<b>{point.x: %e %b %y}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
      series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            align: 'center',
            color: '#FFFFFF'
          },
        }
      },
      series: [
        {
          name: 'Work Items Completed',
          color: '#00cc99',
          data: []
        }
      ],
      drilldown: {
        series: []
      }
    };
  }

  injectMockInformation(startDate: string, endDate: string) {

  }

  onNavigationCategoryClick(categoryName) {

  }

}



